import React, { createContext, useContext, useState } from "react";

const FlowContext = createContext(null);

const initial = {
  tool: null,
  category: null,
  question: null,
  subQuestionId: null,
  answers: {
    name: "",
    dob: "",
    birthTime: "",
    birthTimeKnown: false,
    birthplace: null,
    contextId: null,
    contextLabel: null,
    tier: null,
    personB: null,
    topic: null,
  },
};

export function FlowProvider({ children }) {
  const [flow, setFlow] = useState(initial);

  const update = (patch) => setFlow((f) => ({ ...f, ...patch }));
  const updateAnswers = (patch) => setFlow((f) => ({ ...f, answers: { ...f.answers, ...patch } }));
  const reset = () => setFlow(initial);

  return (
    <FlowContext.Provider value={{ flow, update, updateAnswers, reset, setFlow }}>
      {children}
    </FlowContext.Provider>
  );
}

export const useFlow = () => useContext(FlowContext);
